import { find,omit,set } from 'lodash';
import {
    NATWEST,
    RBS,
    NATWEST_BRAND,
    NWB_BRAND,
    RBS_BRAND,
    ANALYTICS_CHECKBOXNAME,
    ANALYTICS_CHECKBOXOPTION,
    ANALYTICS_CHECKBOX,
    ANALYTICS_DATEFIELD,
    ANALYTICS_DATEFIELDTITLE,
    ANALYTICS_DATEFIELDOPTION,
    ANALYTICS_TEXTFIELDTITLE,
    ANALYTICS_TEXTFIELD,
    ANALYTICS_DROPDOWNNAME,
    ANALYTICS_DROPDOWNOPTION,
    ANALYTICS_RADIOBUTTONTITLE,
    ANALYTICS_RADIOBUTTONOPTION,
    ANALYTICS_FORM_ERROR,
    VALUE_AND_LABEL_TYPE,
    LABEL_TYPE,
    ANALYTICS_APPLICATION_DATA,
    ANALYTICS_DIGITAL_DATA,
    DIGITAL_DATA,
    APPLICATION,
    FORM,
    FORMFIELD,
    FORMFIELDVALUES,
    ERRORFORMFIELD,
    ERRORMESSAGE,
    ANALYTICS_DROPDOWN,
    ANALYTICS_RADIOBUTTON,
    ANALYTICS_TOOLTIP,
    ANALYTICS_TOOLTIPTITLE,
    ANALYTICS_ESIGNTITLE,
    ANALYTICS_ESIGN,
    ANALYTICS_POSTCODE_TITLE,
    ANALYTICS_POSTCODE_LABEL,
    REQUIREDERROR,
    ANALYTICS_FEEDBACKOPTION,
    ANALYTICS_FEEDBACKNAME,
    ANALYTICS_FEEDBACK
} from '../constants/Constants'
import jsonPath from 'jsonpath';
import { analyticsSubmitDefinition } from '../redux/analyticsSlice';
const DIGITAL_DATA_VALUE_ADAPTER = window.environmentConfig && window.environmentConfig.digitalDataValueAdapter;
const isAnalyticsEnabled = window.environmentConfig && window.environmentConfig.isAnalytics
const applicationStart = 'applicationStart'
const applicationStepName = 'applicationStepName'
const applicationComplete = 'applicationComplete'
const applicationCompleteStepName = 'Application Complete'
const applicationSubmit = 'Submit Application'
const businessArea = window.environmentConfig && window.environmentConfig.businessArea;

/**This function helps to map the brandname for analytics. In future we need to add more brand here
 *@brand - The value of brand is get it from the url 
 **/
const mapBrandForAnalytics = (brand) => {
    switch (brand) {
        case NATWEST_BRAND:
            return NATWEST;
        case NWB_BRAND:
            return NATWEST;
        case RBS_BRAND:
            return RBS;
        default:
            return brand
    }
}

/** 
Help to find brand based on URL to populate in analytics & 
it will return defaultBasicTag which will get updated on redux store 
@formDefinition -This parameter contains all the information about the form 
*/
let applicationBrand;
export const analyticsApplicationStart = (formDefinition) => {
    if (isAnalyticsEnabled) {
        // to get brand name
        const host = window.location.protocol + "//" + window.location.host;
        var regEx = new RegExp(window.environmentConfig.brandRegExp, 'g');
        var brand = host.match(regEx);
        if (brand && brand.length > 0 && window.environmentConfig.brandToThemeMap[brand[0]]) {
            const brandId = window.environmentConfig.brandToThemeMap[brand[0]].brandId;
            applicationBrand = mapBrandForAnalytics(brandId);
        } else {
            applicationBrand= window.environmentConfig.brandToThemeMap.default.brandId;
        }
        const { name: formName, stepDefinitions, team } = formDefinition;
        const { name: StepName } = find(stepDefinitions, ['sequenceNumber', 0]);
        const selectedBusinessAreaIndex = businessArea.indexOf(team);
        const selectedBusinessArea = businessArea.includes(team) ? selectedBusinessAreaIndex + 1 : 0;
        const defaultBasicTag = { page: { name: formName}, application: { brandName: applicationBrand, businessArea: selectedBusinessArea }};
        const digitalData = {...defaultBasicTag, application: {...defaultBasicTag.application, stepName: StepName, applicationType: document.title}};
        submitTrackingInfo(applicationStart, digitalData);
        return defaultBasicTag;
    }
    return {}
}

/**
 * This event has triggered on moving from one step to another step
 * Passing StepName and default data to the D&A network call
 * @param defaultBasicTag  object contain the page, brand and business area of form
 * @param seqNumber contain the form stepnumber
 * @param formDefinition Contain UIschema, DataSchema and stepdefinition of the form
 */
export const analyticsApplicationStepName = (formDefinition, seqNumber, defaultBasicTag) => {
    if (isAnalyticsEnabled) {
        if (formDefinition && formDefinition.stepDefinitions) {
            const { name: StepName } = find(formDefinition.stepDefinitions, ['sequenceNumber', seqNumber]);
            const digitalData = { ...defaultBasicTag, application: { ...defaultBasicTag.application, stepName: StepName,applicationType: document.title } };
            submitTrackingInfo(applicationStepName, digitalData);
        }
    }
}

/**
 * This event has triggered on success call of form submission
 * Passing application id and default data to the D&A network call
 * @param defaultBasicTag  object contain the page, brand and business area of form
 * @param response getting form application Id
 */
export const analyticsApplicationComplete = (defaultBasicTag, response) => {
    if (isAnalyticsEnabled) {
        const digitalData = { ...defaultBasicTag, application: { ...defaultBasicTag.application, stepName: applicationCompleteStepName, applicationType: document.title, applicationID: response.uuid } };
        submitTrackingInfo(applicationComplete, digitalData);
    }
}

/**
 * The event is trigger after the form has submitted
 * All the data has pass to the D&A network call 
 * @param defaultBasicTag  object contain the page, brand and business area of form
 * @param analyticsSubmitDefinitionData Contain application data
 */
export const onAnalyticsApplicationSubmit = (defaultBasicTag, analyticsSubmitDefinitionData) => {
    if (isAnalyticsEnabled) {
        let getApplicationObject;
        if (Object.entries(analyticsSubmitDefinitionData).length > 0) {
            getApplicationObject = generateDigitalData(defaultBasicTag, ANALYTICS_DIGITAL_DATA,analyticsSubmitDefinitionData);
        } else {
            getApplicationObject = generateDigitalData(defaultBasicTag, ANALYTICS_APPLICATION_DATA);
        }
        submitTrackingInfo(applicationSubmit, getApplicationObject);
    }
}

/**
 * Based on analytics data type digital data has generated
 * @param defaultBasicTag  object contain the page, brand and business area of form
 * @param analyticsDataType Analytics event name
 */
const generateDigitalData = (defaultBasicTag, analyticsDataType,analyticsSubmitDefinitionData) => {
    let applicationObject = { ...defaultBasicTag.application, stepName: applicationCompleteStepName, brandName: applicationBrand, applicationType: document.title };
    switch (analyticsDataType) {
        case ANALYTICS_DIGITAL_DATA:
            const submittedData = omit(analyticsSubmitDefinitionData, ['application']);
            const digitalData = {
                ...defaultBasicTag,
                application: { ...applicationObject, ...analyticsSubmitDefinition.application }, ...submittedData
            };
            return digitalData;
        case ANALYTICS_APPLICATION_DATA:
            const applicationData = {
                ...defaultBasicTag,
                application: { ...applicationObject, ...analyticsSubmitDefinition.application }
            };
            return applicationData;
        default:
            const defaultObject = {
                ...defaultBasicTag,
                application: { ...applicationObject }
            };
            return defaultObject;

    }
}

/**
 * Checkbox event has triggered and whenever interact the checkbox component
 * Label and value has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param checkBoxObject This parameter contain label and value of the checkbox component
 * @param options Contain analytics option for checkbox component
 */
export const updateAnalyticsCheckBox = (checkBoxObject, newAnalyticsData, options) => {
    let getAnalyticsData;
    if (isAnalyticsEnabled) {
        if (options.trackingBehaviour === LABEL_TYPE) {
            getAnalyticsData = setLabel(newAnalyticsData, ANALYTICS_CHECKBOXNAME, checkBoxObject);
        } else if (options.trackingBehaviour === VALUE_AND_LABEL_TYPE) {
            getAnalyticsData = setLabelAndValue(newAnalyticsData, ANALYTICS_CHECKBOXNAME, ANALYTICS_CHECKBOXOPTION, checkBoxObject);
        }
        submitTrackingInfo(ANALYTICS_CHECKBOX, getAnalyticsData);
    }
}

/**
 * Update the label for all the component
 * @param newAnalyticsData The label and value of all the component has added to this object
 * @param key Contain analytics field name 
 * @param finalObject This parameter contain label and value of all field component
 * @return newAnalyticsData object contain updated analytics data
 */
const setLabel = (newAnalyticsData, key, finalObject) => {
    const { label } = finalObject;
    let objectKey = (key in DIGITAL_DATA_VALUE_ADAPTER && DIGITAL_DATA_VALUE_ADAPTER[key] !== undefined) ? `${DIGITAL_DATA_VALUE_ADAPTER[key]}.${key}` : `form.${key}`;
    set(newAnalyticsData, objectKey, label);
    return newAnalyticsData;
}

/**
 * Update the label and value of all the component
 * @param newAnalyticsData The label and value of all the component has added to this object
 * @param keyLabel Contain analytics field name
 * @param keyValue Contain analytics field value  
 * @param finalObject This parameter contain label and value of all field component
 * @return newAnalyticsData  object contain updated analytics data
 */
export const setLabelAndValue = (newAnalyticsData, keyLabel, keyValue, finalObject) => {
    const { label, value } = finalObject;
    let key1 = (keyLabel in DIGITAL_DATA_VALUE_ADAPTER && DIGITAL_DATA_VALUE_ADAPTER[keyLabel] !== undefined) ? `${DIGITAL_DATA_VALUE_ADAPTER[keyLabel]}.${keyLabel}` : `form.${keyLabel}`;
    let key2 = (keyValue in DIGITAL_DATA_VALUE_ADAPTER && DIGITAL_DATA_VALUE_ADAPTER[keyValue] !== undefined) ? `${DIGITAL_DATA_VALUE_ADAPTER[keyValue]}.${keyValue}` : `form.${keyValue}`;
    set(newAnalyticsData, key1, label);
    set(newAnalyticsData, key2, value);
    return newAnalyticsData;
}

/**
 * Date field event has triggered and whenever interact the date field component
 * Label and value has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param finalDateObject This parameter contain label and value of the date field component
 * @param newAnalyticsData Contain all analytics data in object
 * @param options Contain analytics option for datefield component
 */
export const updateAnalyticsDateField = (finalDateObject, newAnalyticsData, options) => {
    let getAnalyticsData;
    if (isAnalyticsEnabled) {
        if (options.trackingBehaviour === LABEL_TYPE) {
            getAnalyticsData = setLabel(newAnalyticsData, ANALYTICS_DATEFIELDTITLE, finalDateObject);
        } else if (options.trackingBehaviour === VALUE_AND_LABEL_TYPE) {
            getAnalyticsData = setLabelAndValue(newAnalyticsData, ANALYTICS_DATEFIELDTITLE, ANALYTICS_DATEFIELDOPTION, finalDateObject);
        }
        submitTrackingInfo(ANALYTICS_DATEFIELD, getAnalyticsData);

    }
}

/**
 * Textarea event has triggered and whenever interact the text area component
 * Label has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param textAreaLabel This parameter contain label of the text area component
 * @param newAnalyticsData Contain all analytics data in object
 */
export const updateAnalyticsTextArea = (textAreaLabel, newAnalyticsData) => {
    if (isAnalyticsEnabled) {
        set(newAnalyticsData, `${DIGITAL_DATA_VALUE_ADAPTER[ANALYTICS_TEXTFIELDTITLE]}.${ANALYTICS_TEXTFIELDTITLE}`, textAreaLabel);
        submitTrackingInfo(ANALYTICS_TEXTFIELD, newAnalyticsData);
    }

}

/**
 * Analytics api call has triggered
 * it automatically capture the data from window object and it pass the value to the network call as a unreadable format
 * @param eventName Analytics Event name
 * @param analyticsData Digital data object
 * @param field Analytics field type
 */
export const submitTrackingInfo = (eventName, analyticsData) => {
        window.digitalData = analyticsData;
        window._satellite.track(eventName);
}


/**
 * Input field event has triggered and whenever interact the input field component
 * Label and value has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param finalDateObject This parameter contain label and value of the input field component
 * @param newAnalyticsData Contain all analytics data in object
 * @param options Contain analytics option for Input field component
 */
export const updateAnalyticInput = (inputObject, newAnalyticsData, options) => {
    if (isAnalyticsEnabled) {
        let getAnalyticsData;
        if (options.trackingBehaviour === LABEL_TYPE) {
            getAnalyticsData = setLabel(newAnalyticsData, FORMFIELD, inputObject);
        } else if (options.trackingBehaviour === VALUE_AND_LABEL_TYPE) {
            getAnalyticsData = setLabelAndValue(newAnalyticsData, FORMFIELD, FORMFIELDVALUES, inputObject);
        }
        submitTrackingInfo(FORMFIELD, getAnalyticsData);
    }

}

/**
 * Dropdown field event has triggered and whenever interact the dropdown field component
 * Label and value has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param dropDownObject This parameter contain label and value of the dropdown field component
 * @param newAnalyticsData Contain all analytics data in object
 * @param options Contain analytics option for dropdown component
 */
export const updateAnalyticsDropDown = (dropDownObject, newAnalyticsData, options) => {
    if (isAnalyticsEnabled) {
        let getAnalyticsData;
        if (options.trackingBehaviour === LABEL_TYPE) {
            getAnalyticsData = setLabel(newAnalyticsData, ANALYTICS_DROPDOWNNAME, dropDownObject);
        } else if (options.trackingBehaviour === VALUE_AND_LABEL_TYPE) {
            getAnalyticsData = setLabelAndValue(newAnalyticsData, ANALYTICS_DROPDOWNNAME, ANALYTICS_DROPDOWNOPTION, dropDownObject);
        }
        submitTrackingInfo(ANALYTICS_DROPDOWN, getAnalyticsData);
    }

}

/**
 * RadioButton field event has triggered and whenever interact the radio button field component
 * Label and value has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param radioButtonObject This parameter contain label and value of the radio field component
 * @param newAnalyticsData Contain all analytics data in object
 * @param options Contain analytics option for radio component
 */
export const updateAnalyticsRadioButton = (radioButtonObject, newAnalyticsData, options) => {
    if (isAnalyticsEnabled) {
        let getAnalyticsData;
        if (options.trackingBehaviour === LABEL_TYPE) {
            getAnalyticsData = setLabel(newAnalyticsData, ANALYTICS_RADIOBUTTONTITLE, radioButtonObject);
        } else if (options.trackingBehaviour === VALUE_AND_LABEL_TYPE) {
            getAnalyticsData = setLabelAndValue(newAnalyticsData, ANALYTICS_RADIOBUTTONTITLE, ANALYTICS_RADIOBUTTONOPTION, radioButtonObject);
        }
        submitTrackingInfo(ANALYTICS_RADIOBUTTON, getAnalyticsData);
    }

}

/**
 * get all types of error message(limit error type, pattern error type and required error type) in form whenever click on next button
 * return the label as field name of the form and value as error message of the form
 * @param errors This parameter contain all type of error message
 * @param formState Contain schema of the form
 */
export const getErrorMessage = (errors, formState) => {
    const tempError = errors.map(error => {
        if (Object.hasOwn(error, 'property')) {
            const selectedObject = error.property.split(".");
            const selectedParams = selectedObject[selectedObject.length - 1];
            error = setErrorLabel(error, formState, selectedParams);
            return { label: error.label || error.name, errors: error.message };
        } else {
            const selectedError = error.stack.split(":");
            const selectedParams = selectedError[0];
            error = setErrorLabel(error, formState, selectedParams);
            return { label: error.label || error.name, errors: selectedError[1].trim() };
        }
    })
    return tempError;
}

/**
 * return error message of the form
 * @param error This parameter contain error message
 * @param formState Contain schema of the form
 * @param selectedParams Contain the current element name of the form
 */
const setErrorLabel = (error, formState, selectedParams) => {
    const selectedPath = jsonPath.paths(formState.schema, '$..' + selectedParams)[0];
    if (selectedPath) {
        let stringfypath = jsonPath.stringify(selectedPath);
        let queryField = jsonPath.query(formState.schema, stringfypath)[0];
        error.label = queryField?.title;
    }
    return error;
}

/**
 * Event triggered for all component whether having the error message
 * Label and value has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param errors This parameter contain all required error message
 * @param newAnalyticsData Contain all analytics data in object
 * @param options Contain analytics option for error message
 */
export const updateAnalyticsErrorMessage = (errors, newAnalyticsData, formState, defaultBasicTag) => {
  
    if (isAnalyticsEnabled) {
        const errorMessage = getErrorMessage(errors, formState);
        const fieldErrorLabel = errorMessage.map((error) => error.label);
        const fieldErrorMessage = errorMessage.map((error) => error.errors);
        const finalFieldErrorLable = JSON.stringify(fieldErrorLabel).replace(/\[/g, '').replace(/\]/g, '');
        const finalFieldErrorMessage = JSON.stringify(fieldErrorMessage).replace(/\[/g, '').replace(/\]/g, '');
        const errorObject = { label: finalFieldErrorLable, value: finalFieldErrorMessage };
        const getAnalyticsData = setLabelAndValue(newAnalyticsData, ERRORFORMFIELD, ERRORMESSAGE, errorObject);
        const finalErrorObject = { ...defaultBasicTag, ...getAnalyticsData };
        submitTrackingInfo(ANALYTICS_FORM_ERROR, finalErrorObject);
    }
}


/**
 * Event has triggered and whenever hint text popup is open 
 * Label has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param analyticsToolTip Label of the field which contain hint text
 * @param newAnalyticsData Contain all analytics data in object
 */
export const updateAnalyticsHint = (analyticsToolTip, newAnalyticsData) => {
    if (isAnalyticsEnabled) {
        let getAnalyticsData;
        getAnalyticsData = setLabel(newAnalyticsData, ANALYTICS_TOOLTIPTITLE, analyticsToolTip);
        submitTrackingInfo(ANALYTICS_TOOLTIP, getAnalyticsData);
    }

}


/**
 * Event has triggered and whenever interact with component
 * Label has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param esignObject field label
 * @param newAnalyticsData Contain all analytics data in object
 */
export const updateAnalyticsEsign = (esignObject, newAnalyticsData) => {
    if (isAnalyticsEnabled) {
        let getAnalyticsData;
        getAnalyticsData = setLabel(newAnalyticsData, ANALYTICS_ESIGNTITLE, esignObject);
        submitTrackingInfo(ANALYTICS_ESIGN, getAnalyticsData);
    }

}

/**
 * Event has triggered and whenever interact with component
 * Label has updated in newAnalyticsData object
 * Pass newanalyticsdata object as a payload to D&A network call 
 * @param postCodeObject  Contain field label
 * @param newAnalyticsData Contain all analytics data in object
 */
export const updateAnalyticsPostcode  = (postCodeObject, newAnalyticsData) => {
    if (isAnalyticsEnabled) {
        submitTrackingInfo(ANALYTICS_POSTCODE_LABEL, setLabel(newAnalyticsData, ANALYTICS_POSTCODE_TITLE, postCodeObject));
    }
}

/**
 * Event has triggered whenever interact with component
 * Set all the basic tagging digital data for before submitting the form
 * @param submitDataTag Contain basic tagging digital data(loan,investment etc)
 * @param defaultBasicTag Contain basic tagging default data(page, stepname, formName etc)
 * @param formDataTag Contain Advance tagging form data(summary widget checkbox)
 */
export const setTaggingData = (submitDataTag, defaultBasicTag, stepName, formDataTag, brandName) => {
    if (Object.entries(submitDataTag).length > 0) {
        const digitalData = { ...defaultBasicTag, application: { ...defaultBasicTag.application, stepName: stepName, brandName: brandName, applicationType: document.title, ...submitDataTag.application },  ...formDataTag, ...submitDataTag };
        window.digitalData = digitalData;
    }
}

export const updateAnalyticsFeedbackStar = (feedbackObject, newAnalyticsData, options) => {
    if (isAnalyticsEnabled) {
        let getAnalyticsData;
        if (options.trackingBehaviour === LABEL_TYPE) {
            getAnalyticsData = setLabel(newAnalyticsData, ANALYTICS_FEEDBACKNAME, feedbackObject);
        } else if (options.trackingBehaviour === VALUE_AND_LABEL_TYPE) {
            getAnalyticsData = setLabelAndValue(newAnalyticsData, ANALYTICS_FEEDBACKNAME, ANALYTICS_FEEDBACKOPTION, feedbackObject);
        }
        submitTrackingInfo(ANALYTICS_FEEDBACK, getAnalyticsData);
    }
}